import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../App';
import { Loader2, ShieldAlert } from 'lucide-react';

const AdminRoute = ({ children }) => {
  const { authUser, authLoading, userProfile } = useAppContext();

  if (authLoading) {
    return (
      <div className="h-screen flex flex-col items-center justify-center bg-gray-50">
        <Loader2 className="w-10 h-10 text-blue-600 animate-spin mb-4" />
        <p className="text-gray-500 font-bold">Verifying Security Clearance...</p>
      </div>
    );
  }

  if (!authUser || userProfile?.role !== 'super_admin') {
    return (
      <div className="h-screen flex flex-col items-center justify-center bg-red-50 text-red-800">
        <ShieldAlert className="w-16 h-16 mb-4" />
        <h1 className="text-3xl font-black uppercase">Access Denied</h1>
        <p className="mt-2">This area is restricted to Super Administrators.</p>
        <div className="mt-4"><Navigate to="/dashboard" replace /></div>
      </div>
    );
  }

  return children;
};

export default AdminRoute;